export default __webpack_public_path__ + "static/media/sendbbx.e2e956ce.mp3";